import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";


export function fieldsMatchValidator(field1: string, field2: string): ValidatorFn {
  return (formGroup: AbstractControl): ValidationErrors | null => {
    const value1 = formGroup.get(field1)?.value;
    const value2 = formGroup.get(field2)?.value;

    if (value1 !== value2) {
      return { fieldsDoNotMatch: true };
    }

    return null;
  };
}

export function validatorAmountRange(range: number[], amount: string): ValidatorFn {
  return (formGroup: AbstractControl): ValidationErrors | null => {

    let valueAmount = formGroup.get(amount)?.value;

    if (valueAmount === null) {
      return { amountOutOfRange: true };
    }
    valueAmount = valueAmount.split('.').join('');

    if (valueAmount < range[0] || valueAmount > range[1]) {
      return { amountOutOfRange: true };
    }
    return null;
  };
}
